import { isGroupTableQuery } from 'owa-group-utils';
import type { MailFolderTableQuery, TableQuery } from 'owa-mail-list-store';
import {
    MailSortHelper,
    type TableQueryType,
    isCatchUpFilter,
    isHeadlinesFilter,
} from 'owa-mail-list-store';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import type { TraceErrorObject } from 'owa-analytics-types';
import { shouldDistinguishedFolderSortByRenewTime } from './shouldDistinguishedFolderSortByRenewTime';

export function shouldFolderSortByRenewTime(folderId: string): boolean {
    // Folder id should not be null if not in search mode
    if (!folderId) {
        // If folderId is empty, then we don't know enough about the table to
        // determine if it should sort by renew time (so we default to false).
        if (folderId === '') {
            return false;
        }

        const error: TraceErrorObject = new Error('Current folder id should not be null');
        error.additionalInfo = { ty: typeof folderId };
        throw error;
    }

    const folderName = folderIdToName(folderId);
    return shouldDistinguishedFolderSortByRenewTime(folderName);
}

export default function shouldTableSortByRenewTime(tableQuery: TableQuery): boolean {
    if (isGroupTableQuery(tableQuery)) {
        return false;
    }

    if (tableQuery.type == 0) {
        const tableSortby = (tableQuery as MailFolderTableQuery).sortBy;
        const renewTimeSort = MailSortHelper.getSortBySupportingPin();
        return (
            tableSortby.sortColumn == renewTimeSort.sortColumn &&
            tableSortby.sortDirection == renewTimeSort.sortDirection &&
            shouldFolderSortByRenewTime(tableQuery.folderId) &&
            !isCatchUpFilter(tableQuery as MailFolderTableQuery) &&
            !isHeadlinesFilter(tableQuery as MailFolderTableQuery)
        );
    } else {
        return tableQuery.type == 1;
    }
}
